var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNotFoundIllustration(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 157,
    height: 175,
    viewBox: "0 0 157 175",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M150.977 163.145C150.977 167.761 134.753 171.761 111.074 173.719C101.171 174.541 89.9661 175 78.1003 175C66.2345 175 55.0266 174.539 45.1265 173.719C21.4479 171.761 5.22363 167.761 5.22363 163.145C5.22363 158.529 21.4479 154.526 45.1265 152.568C55.0292 151.746 66.2345 151.287 78.1003 151.287C89.9661 151.287 101.174 151.749 111.074 152.568C134.753 154.526 150.977 158.529 150.977 163.145Z",
    fill: "#444444"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M111.074 135.863V173.718C101.171 174.541 89.9656 175 78.0998 175C66.234 175 55.0261 174.538 45.126 173.718V135.863C45.126 117.65 59.8912 102.89 78.0998 102.89C87.2041 102.89 95.4488 106.58 101.415 112.546C107.384 118.512 111.074 126.757 111.074 135.863Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M92.3638 151.287C96.5407 151.287 99.9268 147.901 99.9268 143.724C99.9268 139.547 96.5407 136.161 92.3638 136.161C88.1869 136.161 84.8008 139.547 84.8008 143.724C84.8008 147.901 88.1869 151.287 92.3638 151.287Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M63.8335 151.287C68.0105 151.287 71.3966 147.901 71.3966 143.724C71.3966 139.547 68.0105 136.161 63.8335 136.161C59.6566 136.161 56.2705 139.547 56.2705 143.724C56.2705 147.901 59.6566 151.287 63.8335 151.287Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M94.2206 148.459C95.3912 148.459 96.3402 147.51 96.3402 146.339C96.3402 145.169 95.3912 144.22 94.2206 144.22C93.05 144.22 92.1011 145.169 92.1011 146.339C92.1011 147.51 93.05 148.459 94.2206 148.459Z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M65.6904 148.459C66.861 148.459 67.8099 147.51 67.8099 146.339C67.8099 145.169 66.861 144.22 65.6904 144.22C64.5198 144.22 63.5708 145.169 63.5708 146.339C63.5708 147.51 64.5198 148.459 65.6904 148.459Z",
    fill: "black"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M132.447 123.531H23.75L31.9629 98.7941L37.0695 83.3975L38.945 77.7471L48.1421 50.0364L55.1269 28.9894L63.6422 3.33187C64.3028 1.3423 66.1623 0 68.258 0H87.9362C90.0345 0 91.8941 1.3423 92.552 3.33187L101.07 28.992L108.055 50.039L117.252 77.7498L119.127 83.4002L124.234 98.7968L132.447 123.534V123.531Z",
    fill: "#FFCC00"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M151.796 132.333H4.40093C1.971 132.333 0 130.362 0 127.932C0 125.502 1.971 123.531 4.40093 123.531H151.796C154.226 123.531 156.197 125.502 156.197 127.932C156.197 130.362 154.226 132.333 151.796 132.333Z",
    fill: "#FF9900"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M108.055 50.0363H48.1421L55.1268 28.9893H101.07L108.055 50.0363Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M124.237 98.7941H31.9604L38.9452 77.7471H117.252L124.237 98.7941Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotFoundIllustration);
export default __webpack_public_path__ + "static/media/NotFoundIllustration.850fe23fcfbbd37f611056e13d980334.svg";
export { ForwardRef as ReactComponent };